import { LengthPoints, SubPoint, Point } from "../NodeDXF/Point";
function canvas_arrow(context, fromx, fromy, tox, toy) {
    var headlen = 10; // length of head in pixels
    var dx = tox - fromx;
    var dy = toy - fromy;
    var angle = Math.atan2(dy, dx);
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
    // context.moveTo(tox, toy);
    //  context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
}
function fitCircleToPoints(x1, y1, x2, y2, x3, y3) {
    // check if the points form a straight line
    const slopeA = (x2 - x1) / (y1 - y2);
    const slopeB = (x3 - x2) / (y2 - y3);
    if (slopeA === slopeB) {
        return;
    }
    // calculate center coordinates
    let x, y;
    if (y1 === y2) {
        x = (x1 + x2) / 2;
        y = slopeB * x + ((y2 + y3) / 2 - (slopeB * (x2 + x3)) / 2);
    }
    else if (y2 === y3) {
        x = (x2 + x3) / 2;
        y = slopeA * x + ((y1 + y2) / 2 - (slopeA * (x1 + x2)) / 2);
    }
    else {
        x =
            ((y2 + y3) / 2 -
                (slopeB * (x2 + x3)) / 2 -
                (y1 + y2) / 2 +
                (slopeA * (x1 + x2)) / 2) /
                (slopeA - slopeB);
        y = slopeA * x + (y1 + y2) / 2 - (slopeA * (x1 + x2)) / 2;
    }
    // calculate radius and CCW
    const radius = Math.sqrt(Math.pow((x1 - x), 2) + Math.pow((y1 - y), 2));
    const CCW = (x3 - x1) * (y2 - y1) - (y3 - y1) * (x2 - x1) >= 0;
    return { x, y, radius, CCW };
}
export let DrawLine = (o, context, contour, bends) => {
    let point = Point.fromXYZ(0, 0, 0);
    let last = null;
    let c = 0;
    //console.log('>>', o);
    if (o.points && o.points.length > 0) {
        last = o.points[o.points.length - 1];
        for (let index = 0; index < o.points.length; index++) {
            const element = o.points[index];
            point = point.addPoint(element);
            c++;
            if (last.Bulge) {
                DrawBulge(last, element, contour, context);
            }
            else {
                DrawNormalLine(last, element, contour, context);
            }
            last = element;
        }
        context.lineWidth = 1;
    }
    let bend = bends.find((v) => v.id == o.id);
    if (point && bend) {
        DrawFoldInfo(bend, context, contour, point.scale(c));
    }
};
function DrawFoldInfo(bend, context, contour, at) {
    let t = bend.value > 0 ? bend.value + "° Up" : Math.abs(bend.value) + "° Down";
    let fontHeight = 10;
    context.font = fontHeight + "pt Helvetica";
    context.fillStyle = "blue";
    context.strokeStyle = "white";
    let text = context.measureText(t);
    context.strokeText(t, contour.scaleX(at.x) - text.width / 2, contour.scaleY(at.y) + fontHeight);
    context.fillText(t, contour.scaleX(at.x) - text.width / 2, contour.scaleY(at.y) + fontHeight);
}
function DrawNormalLine(a, b, contour, context) {
    context.beginPath();
    // canvas_arrow(
    //   context,
    //   contour.scaleX(a.x),
    //   contour.scaleY(a.y),
    //   contour.scaleX(b.x),
    //   contour.scaleY(b.y)
    // );
    context.moveTo(contour.scaleX(a.x), contour.scaleY(a.y));
    context.lineTo(contour.scaleX(b.x), contour.scaleY(b.y));
    context.stroke();
    context.closePath();
    // context.fillStyle = "green";
    // context.fillText(
    //   "" + index,
    //   contour.scaleX(last.x),
    //   contour.scaleY(last.y)
    // );
}
function DrawBulge(a, b, contour, context) {
    let len = LengthPoints(a, b);
    let s = SubPoint(a, b);
    let rotation = Math.atan(s.y / s.x) + 90 * (Math.PI / 180);
    //This WILL need more work.
    /*autocad_2012_pdf_dxf-reference_enu.pdf PAGE 149 Bulge (optional; default is 0). The bulge is the tangent of one fourth the included angle for an
  arc segment, made negative if the arc goes clockwise from the start point to the endpoint. A
  bulge of 0 indicates a straight segment, and a bulge of 1 is a semicircle*/
    let invertBulge = 1;
    if (a.x < b.x)
        invertBulge = -1;
    let x = (len * Math.cos(rotation) * (a.Bulge * invertBulge)) / 2;
    let y = (len * Math.sin(rotation) * (a.Bulge * invertBulge)) / 2;
    let m2 = a.midPoint(b).addPoint(Point.fromXYZ(x, y, 0));
    let points = [
        contour.scaleX(b.x),
        contour.scaleY(b.y),
        contour.scaleX(m2.x),
        contour.scaleY(m2.y),
        contour.scaleX(a.x),
        contour.scaleY(a.y),
    ];
    const circle = fitCircleToPoints(points[0], points[1], points[2], points[3], points[4], points[5]);
    if (circle) {
        const ang1 = Math.atan2(points[1] - circle.y, points[0] - circle.x);
        const ang2 = Math.atan2(points[5] - circle.y, points[4] - circle.x);
        context.beginPath();
        context.arc(circle.x, circle.y, circle.radius, ang1, ang2, circle.CCW);
        context.stroke();
        context.closePath();
    }
    //context.strokeText(rotation / (Math.PI / 180), contour.scaleX(b.x), contour.scaleY(b.y));
    //	context.strokeText(b.y, contour.scaleX(b.x), contour.scaleY(b.y));
    //context.strokeText(last.Bulge, contour.scaleX(b.x), contour.scaleY(b.y));
}
